import { render, staticRenderFns } from "./TenderCheck.vue?vue&type=template&id=87921c16&scoped=true"
import script from "./TenderCheck.vue?vue&type=script&lang=js"
export * from "./TenderCheck.vue?vue&type=script&lang=js"
import style0 from "./TenderCheck.vue?vue&type=style&index=0&id=87921c16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87921c16",
  null
  
)

export default component.exports